import type { Retention } from "../shared/contracts";

export const retentionLabels: Record<Retention, string> = {
  "1d": "1 天",
  "7d": "7 天",
  "30d": "30 天",
  keep: "永久",
};

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  let index = 0;
  while (value >= 1024 && index < units.length - 1) {
    value /= 1024;
    index += 1;
  }
  return `${value >= 10 ? value.toFixed(1) : value.toFixed(2)} ${units[index]}`;
}

export function formatDate(value: string): string {
  return new Intl.DateTimeFormat("zh-CN", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function fileKind(contentType: string): string {
  if (contentType.startsWith("image/")) return "图片";
  if (contentType.startsWith("video/")) return "视频";
  if (contentType.startsWith("audio/")) return "音频";
  if (contentType.includes("pdf")) return "PDF";
  if (contentType.includes("zip") || contentType.includes("compressed")) return "压缩包";
  if (contentType.startsWith("text/")) return "文本";
  return "文件";
}
